import axios from "axios";

export async function verifyToken(token) {
    if (!token) return false;
    try {
        await axios.post('token/verify/', { token });
        return true;
    } catch {
        return false;
    }
}

export async function refreshAccessToken(refreshToken) {
    try {
        const response = await axios.post('token/refresh/', { refresh: refreshToken });
        return response.data.access; // Return new access token
    } catch (error){
        console.error('error refreshing token: ', error)
        return null;
    }
}
